export default __webpack_public_path__ + "static/media/home-business-blog-img03.8d8893ac.jpg";